/** @module Enums */ /** typedoc */

export enum ReleaseStoreCategoryEnum {
    Other = 'Other',
    Recognition = 'Recognition',
    Specialized = 'Specialized',
    Top = 'Top',
    Monetization = 'Monetization'
}
